import React from 'react'
import { Form } from 'react-bootstrap'
import { chartSupportsLineStrokeWidth, chartSupportsSeriesGrid } from '../../services/chartCapabilities'

export default function LayoutStylePanel({
  theme,
  setTheme,
  currentChart,
  visualOptions,
  setVisualOptions,
}) {
  const markOpacity = Number(theme?.markOpacity ?? 1)
  const opacityPercent = Math.round(markOpacity * 100)
  const lineStrokeScale = Number(theme?.lineStrokeScale ?? 1)
  const lineStrokePercent = Math.round(lineStrokeScale * 100)
  const chartId = currentChart?.metadata?.id || ''
  const supportsLineStrokeWidth = chartSupportsLineStrokeWidth(chartId)
  const supportsSeriesGrid = chartSupportsSeriesGrid(chartId)
  const seriesGridEnabled = Boolean(visualOptions?.showGrid ?? false)

  const updateOpacity = (value) => {
    const nextOpacity = Math.max(0.1, Math.min(1, Number(value) || 1))
    setTheme({ ...theme, markOpacity: Number(nextOpacity.toFixed(2)) })
  }

  const updateLineStrokeScale = (value) => {
    const nextScale = Math.max(0.5, Math.min(3, Number(value) || 1))
    setTheme({ ...theme, lineStrokeScale: Number(nextScale.toFixed(2)) })
  }

  const updateSeriesGrid = (enabled) => {
    setVisualOptions({
      ...visualOptions,
      showGrid: enabled,
    })
  }

  return (
    <>
      <div className="appearance-section">
        <label className="appearance-swatch-label" htmlFor="chart-mark-opacity">
          Chart mark opacity
        </label>
        <div className="layout-style-slider-row">
          <input
            id="chart-mark-opacity"
            type="range"
            min="0.1"
            max="1"
            step="0.05"
            value={markOpacity}
            onChange={(event) => updateOpacity(event.target.value)}
            className="custom-range layout-style-slider"
          />
          <span className="layout-style-slider-value">{opacityPercent}%</span>
        </div>
        <div className="small text-muted">
          Applies to chart marks such as bars, bubbles, nodes, links, arcs, and
          areas.
        </div>
      </div>

      {supportsSeriesGrid ? (
        <div className="appearance-section">
          <label className="appearance-swatch-label" htmlFor="chart-series-grid">
            Series grid
          </label>
          <div className="layout-style-slider-row">
            <Form.Check
              id="chart-series-grid"
              type="switch"
              checked={seriesGridEnabled}
              onChange={(event) => updateSeriesGrid(event.target.checked)}
              label={seriesGridEnabled ? 'On' : 'Off'}
            />
          </div>
          <div className="small text-muted">
            Shows or hides the series/small-multiple cell border used by some
            charts.
          </div>
        </div>
      ) : null}

      {supportsLineStrokeWidth ? (
        <div className="appearance-section">
          <label className="appearance-swatch-label" htmlFor="chart-line-stroke-scale">
            Line width
          </label>
          <div className="layout-style-slider-row">
            <input
              id="chart-line-stroke-scale"
              type="range"
              min="0.5"
              max="3"
              step="0.05"
              value={lineStrokeScale}
              onChange={(event) => updateLineStrokeScale(event.target.value)}
              className="custom-range layout-style-slider"
            />
            <span className="layout-style-slider-value">{lineStrokePercent}%</span>
          </div>
          <div className="small text-muted">
            Adjusts the width of line-based charts, such as line charts and
            parallel coordinates.
          </div>
        </div>
      ) : null}
    </>
  )
}
